'use strict';

class ScrollWatcher{
	constructor(callback){
		this.ticking = false;
		this.lastKnownPosition = 0;
		this.callback = callback;

		document.addEventListener('scroll', this.scrollListener.bind(this));
	}

	scrollListener(){
		this.lastKnownPosition = window.scrollY;
		if(!this.ticking){
			window.requestAnimationFrame(() => {
				this.callback(this.lastKnownPosition);
				this.ticking = false;
			});
			this.ticking = true;
		}
	}
}

export default ScrollWatcher;


// WEBPACK FOOTER //
// ./scripts/util/ScrollWatcher.js